import React from 'react'

export default function NiceUnderline({children, className}) {
  return (
    <span className={`font-bold NiceUnderline + ${className}`}>
      {children}
    </span>
  )
}
